import createBlocker from './utils/create-blocker';
import createState from './utils/create-state';
import getInitialConfig from './utils/get-initial-config';

/**
 * Initiates lazy hydration on elements with "lazy-hydration" class.
 * @param $context context element
 */
export default function($context = null) {
    const $elements = $context
        ? $context.getElementsByClassName('lazy-hydration')
        : document.getElementsByClassName('lazy-hydration');

    if ($elements.length) {
        for (let i = 0, eLen = $elements.length; i < eLen; i++) {
            const $element = $elements[i];
            const modules = $element.dataset.modules.split(' ');

            createState($element);

            if (modules.length > 1) {
                const hydrationTypes = $element.dataset.hydration ? $element.dataset.hydration.split(' ') : ['whenVisible'];
                let blockersCreated = 0;

                for (let moduleIndex = 0, modulesLen = modules.length; moduleIndex < modulesLen; moduleIndex++) {
                    const moduleName = modules[moduleIndex];
                    const hydrationType = hydrationTypes[moduleIndex] || hydrationTypes[0];

                    createBlocker(
                        $element,
                        hydrationType,
                        () => {
                            import(LAZY_HYDRATION_PATH + moduleName).then(({ default: hydrate}) => {
                                hydrate({ $element, initialConfig: getInitialConfig($element, moduleName), hydrationType });
                            });
                        }
                    );
                    blockersCreated++;
                }

                $element.hydrationState.blockersCreated += blockersCreated;
            } else {
                const moduleName = $element.dataset.modules;
                const hydrationType = $element.dataset.hydration || 'whenVisible';

                createBlocker(
                    $element,
                    hydrationType,
                    () => {
                        import(LAZY_HYDRATION_PATH + moduleName).then(({ default: hydrate}) => {
                            hydrate({ $element, initialConfig: getInitialConfig($element, moduleName), hydrationType });
                        });
                    }
                );
                $element.hydrationState.blockersCreated++;
            }
        }
    }
}